module.exports = __webpack_public_path__ + "static/media/SerifGoodOptimized.80337bbf.jp2";